import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainRouter from "./Router/MainRouter.js";
import "./App.css";
import usePreventBounce from "./Components/CustomHooks/PreventBounce.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useIdleTimer } from "./_V2/CustomHooks/useIdleTimer.jsx";
import SessionExpiredPopup from "./_V2/popups/SessionResetPopup.jsx";
import { updateSession } from "./_V2/Pages/Dashboard/dashboard.slice.js";

function App() {
  const dispatch = useDispatch();
  const isIdle = useIdleTimer(1800000);
  usePreventBounce();

  const isAuthUser = localStorage.getItem("isAuthUser");

  useEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0 });
  }, []);

  useEffect(() => {
    if (isIdle) {
      dispatch(updateSession(true));
    }
  }, [isIdle]);

  return (
    <div className="App overflow-x-hidden md:overflow-x-visible">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <MainRouter isAuthenticated={isAuthUser} />
    </div>
  );
}

export default App;
